import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LogoLockup } from "../components/LogoMark";

export default function AdminLogin() {
  const { login, token } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (token) nav("/admin"); }, [token, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    }
    setLoading(false);
  };

  const inputCls = "w-full bg-white/[0.03] border border-white/10 rounded-2xl px-4 py-3.5 text-white placeholder:text-white/35 focus:outline-none focus:border-steel-light/60 transition-all";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink-950 glow relative flex items-center justify-center px-6">
      <Link to="/" className="absolute top-8 left-8 flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors">
        <ArrowLeft className="h-4 w-4" /> Back to site
      </Link>
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="relative z-10 w-full max-w-md glass rounded-4xl p-10">
        <div className="mb-8"><LogoLockup dark className="h-9" /></div>
        <div className="flex items-center gap-2 mb-2"><Lock className="h-4 w-4 text-steel-light" /><p className="overline text-steel-light">Client Portal</p></div>
        <h1 className="font-serif text-gradient text-4xl mb-8" style={{ fontWeight: 500 }}>Sign in.</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input data-testid="admin-email" type="email" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" type="password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="btn-pill w-full bg-white text-ink-950 py-4 text-sm font-600 hover:shadow-xl hover:shadow-white/20 disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-white/40 text-xs">Authorized personnel only. Contact your account manager for access.</p>
      </motion.div>
    </div>
  );
}
